module.exports = __webpack_public_path__ + "img/pic9.14b352a1.jpg";